import produce from 'immer';
import { SET_CLEAR_CUSTOMER } from 'containers/WorkQueue/constants';
import { SET_COMMENTS, SET_COMMENT_TYPES } from './constants';

export const initialState = {
  commentsList: [],
  commentTypeList: [],
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SET_COMMENTS:
        draft.commentsList = payload;
        break;
      case SET_CLEAR_CUSTOMER:
        draft.commentsList = initialState.commentsList;
        break;
      case SET_COMMENT_TYPES:
        draft.commentTypeList = payload;
        break;
      default: {
        break;
      }
    }
  });

export default reducer;
